var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDominance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1469_7660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H51V51H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1469_7660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 49.5059H22.3125L20.7188 43.0312H30.2813L28.6875 49.5059Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2344 18.3282C42.2344 9.08613 34.7422 1.4943 25.5002 1.4942C16.2663 1.4941 8.79329 9.043 8.7657 18.2769C8.74737 24.3745 11.9908 29.7151 16.8495 32.6549C18.2519 33.5035 19.125 35.0076 19.125 36.6468C19.125 36.6616 18.4962 36.6563 31.875 36.6563C31.875 34.9644 32.7618 33.4878 34.095 32.6883C38.9708 29.7639 42.2344 24.4276 42.2344 18.3282Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.875 43.0312H19.125V36.6562H31.875V43.0312Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 36.6562V22.3125C28.6875 20.5521 30.1146 19.125 31.875 19.125C33.6354 19.125 35.0625 20.5521 35.0625 22.3125C35.0625 24.0729 33.6354 25.5 31.875 25.5H19.125C17.3646 25.5 15.9375 24.0729 15.9375 22.3125C15.9375 20.5521 17.3646 19.125 19.125 19.125C20.8854 19.125 22.3125 20.5521 22.3125 22.3125V36.6562H28.6875Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8125 6.375L46.2188 7.96875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8125 30.2812L46.2188 28.6875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 18.3281H47.8125",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1875 6.375L4.78125 7.96875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1875 30.2812L4.78125 28.6875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 18.3281H3.1875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDominance);
export default __webpack_public_path__ + "static/media/icon-dominance.c11adba8967448c13db93be2e79d6379.svg";
export { ForwardRef as ReactComponent };